import { render, staticRenderFns } from "./Bars.vue?vue&type=template&id=577021f0&"
import script from "./Bars.vue?vue&type=script&lang=js&"
export * from "./Bars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports